import { RootState } from "@/store/types";
import axios from "axios";
import { ActionTree } from "vuex";
import { StatisticState, DetailFilterParams, GroupFilterParams } from "./types";

export const actions: ActionTree<StatisticState, RootState> = {
  async getTelegramOtpStatisticDetail({commit}, data: DetailFilterParams) {
    try {
      const resp = await axios({
        url: '/stats-api/detail/telegram_otp',
        params: data
      });
      let messages = resp.data?.messages ?? []
      if (data.page_number > 1) {
        commit('pushTelegramOtpStatisticDetail', messages);
      } else {
        commit('setTelegramOtpStatisticDetail', messages);
      }
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async exportTelegramOtpStatisticDetail({commit}, filter: DetailFilterParams) {
    try {
      const resp = await axios({
        url: '/stats-api/detail/telegram_otp/export',
        params: filter
      });
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async getTelegramOtpStatisticDetailInfo({commit, dispatch}, id: string) {
    try {
      const resp = await axios({
        url: "/stats-api/detail/telegram_otp/" + id.replace(/#/g, "%23"),
      })
      return resp;
    } catch (error) {
      throw error;
    }
  },
  async getTelegramOtpStatisticGroup({commit}, filter: GroupFilterParams) {
    try {
      const resp = await axios({
        url: '/stats-api/group/telegram_otp',
        params: filter
      });
      commit('setTelegramOtpStatisticGroup', resp.data);
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async exportTelegramOtpStatisticGroup({commit}, filter: GroupFilterParams) {
    try {
      const resp = await axios({
        url: '/stats-api/group/telegram_otp/export',
        params: filter
      });
      return resp;
    } catch (err) {
      throw err;
    }
  },
};
